import { MdWifiOff } from 'react-icons/md';

interface OfflineIndicatorProps {
  isOffline: boolean;
}

export const OfflineIndicator = ({ isOffline }: OfflineIndicatorProps) => {
  if (!isOffline) {
    return null;
  }

  return (
    <div className="fixed top-4 left-4 z-50 bg-danger rounded-lg p-3 shadow-lg">
      <div className="flex items-center gap-3">
        <MdWifiOff size={24} className="text-white" />
        <span className="text-white text-base font-medium">You are offline</span>
      </div>
    </div>
  );
};
